import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { DirectorListPageService } from '@/pages/Directors/services';

const MODULE_NAME = 'profile.machines.states.suspendUser';

const getSrv = () => {
  return vappContainer.get<DirectorListPageService>(
    DirectorListPageService.displayName
  );
};

export const suspendUser = async (context: any, event: any) => {
  const currentState = 'SUSPEND_USER';
  const method = 'suspendUser';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.suspendUser(event?.payload);
      if (content?.email) {
        return resolve({
          key: 'SUSPEND_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'User suspend failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SUSPEND_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'SUSPEND_USER_FAILED',
        value: _msg,
      });
    }
  });
};
